import { TRole } from '@aksia/infrastructure';
import { Directive, input } from '@angular/core';

@Directive({
  selector: '[appHasRole]',
  standalone: true,
})
export class HasRoleDirective {
  appHasRole = input<TRole | TRole[] | undefined>(undefined);
}
